import React, { useState, useEffect } from "react";
// import {
//   GoogleMap,
//   LoadScript,
//   Marker,
//   DirectionsRenderer,
// } from "@react-google-maps/api";
// import { Card, CardBody, Row, Col } from "reactstrap";

// import React, { useState, useEffect } from "react";
import {
  GoogleMap,
  LoadScript,
  Marker,
  DirectionsRenderer,
  useLoadScript,
} from "@react-google-maps/api";

const containerStyle = {
  width: "100%",
  height: "400px",
};

const googleMapsApiKey = "AIzaSyDhJUwz631fzUN2qeMvMG1_EzM3e2A6QM0"; // Replace with your actual API key

const StylistLocation = ({ orderHistory, userLocation }) => {
  const [map, setMap] = useState(null);
  const [directions, setDirections] = useState(null);
  const [travelTime, setTravelTime] = useState(""); // Store travel duration
  const [stylistAddress, setStylistAddress] = useState("");
  const [userAddress, setUserAddress] = useState("");

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: googleMapsApiKey,
  });

  const stylistLocation =
    orderHistory?.find(item => item.coordinates)?.coordinates || null;

  const fetchAddress = async (latitude, longitude) => {
    const apiUrl = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${googleMapsApiKey}`;
    try {
      const response = await fetch(apiUrl);
      const data = await response.json();
      return data.status === "OK" && data.results.length > 0
        ? data.results[0].formatted_address
        : "Address not found";
    } catch (error) {
      console.error("Error fetching address:", error);
      return "Error fetching address";
    }
  };

  useEffect(() => {
    if (stylistLocation) {
      fetchAddress(stylistLocation.latitude, stylistLocation.longitude).then(
        setStylistAddress
      );
    }
    if (userLocation) {
      fetchAddress(
        userLocation?.location?.latitude,
        userLocation?.location?.longitude
      ).then(setUserAddress);
    }
  }, [stylistLocation, userLocation]);

  const getDirections = () => {
    if (!isLoaded || !stylistLocation || !userLocation) return;

    const directionsService = new window.google.maps.DirectionsService();

    directionsService.route(
      {
        origin: {
          lat: stylistLocation?.latitude,
          lng: stylistLocation?.longitude,
        },
        destination: {
          lat: userLocation?.location?.latitude,
          lng: userLocation?.location?.longitude,
        },
        travelMode: window.google.maps.TravelMode.DRIVING,
      },
      (result, status) => {
        if (status === window.google.maps.DirectionsStatus.OK) {
          setDirections(result);
          const duration =
            result.routes[0]?.legs[0]?.duration?.text || "Unknown time";
          setTravelTime(duration);
        } else {
          console.error("Error fetching directions:", status);
        }
      }
    );
  };

  const openGoogleMaps = () => {
    if (!stylistLocation || !userLocation?.location) return;

    const origin = `${stylistLocation.latitude},${stylistLocation.longitude}`;
    const destination = `${userLocation?.location?.latitude},${userLocation?.location?.longitude}`;
    const googleMapsUrl = `https://www.google.com/maps/dir/?api=1&origin=${origin}&destination=${destination}&travelmode=driving`;

    window.open(googleMapsUrl, "_blank");
  };

  useEffect(() => {
    if (isLoaded && stylistLocation && userLocation?.location) {
      getDirections();
    }
  }, [isLoaded, stylistLocation, userLocation]);

  if (!isLoaded) return <p>Loading Map...</p>;

  return (
    <>
      {stylistLocation && (
        <p>
          <strong>Stylist Address:</strong> {stylistAddress}
        </p>
      )}
      {userLocation?.location && (
        <p>
          <strong>Customer Address:</strong> {userAddress}
        </p>
      )}
      {travelTime && (
        <p>
          <strong>Estimated Travel Time:</strong> {travelTime}
        </p>
      )}

      <div>
        <GoogleMap
          mapContainerStyle={containerStyle}
          center={{
            lat: stylistLocation?.latitude || 0,
            lng: stylistLocation?.longitude || 0,
          }}
          zoom={14}
          onLoad={map => setMap(map)}
          onClick={openGoogleMaps} // Opens Google Maps on click
        >
          {stylistLocation && (
            <Marker
              position={{
                lat: stylistLocation.latitude,
                lng: stylistLocation.longitude,
              }}
              icon={{
                url: "http://maps.google.com/mapfiles/ms/icons/green-dot.png", // Green icon
              }}
              label={{
                text: "Stylist",
                color: "black",
                fontWeight: "bold",
                fontSize: "18px",
              }}
            />
          )}
          {userLocation && (
            <Marker
              position={{
                lat: userLocation.location.latitude,
                lng: userLocation.location.longitude,
              }}
              icon={{
                url: "http://maps.google.com/mapfiles/ms/icons/blue-dot.png", // Blue icon
              }}
              label={{
                text: "Customer",
                color: "black",
                fontWeight: "bold",
                fontSize: "18px",
              }}
            />
          )}
          {directions && <DirectionsRenderer directions={directions} />}
        </GoogleMap>
      </div>
    </>
  );
};

export default StylistLocation;
